export default __webpack_public_path__ + "static/media/psych1.4eb4405a.svg";